/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntegrationEndpointAttribute from './integration-endpoint-attribute';
import IntegrationEndpointAttributeDetail from './integration-endpoint-attribute-detail';
import IntegrationEndpointAttributeUpdate from './integration-endpoint-attribute-update';
import IntegrationEndpointAttributeDeleteDialog from './integration-endpoint-attribute-delete-dialog';

const IntegrationEndpointAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntegrationEndpointAttribute />} />
    <Route path="new" element={<IntegrationEndpointAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<IntegrationEndpointAttributeDetail />} />
      <Route path="edit" element={<IntegrationEndpointAttributeUpdate />} />
      <Route path="delete" element={<IntegrationEndpointAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntegrationEndpointAttributeRoutes;
